
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form, Spin } from 'antd';
import { useAppContext } from "../../../context/appContext";
import { CloseOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const ConnectToRemote = ({ displayConnectHost, setDisplayConnectHost, onConnectHost }) => {

    const [host, setHost] = useState({})

    const goBack = () => {
        setDisplayConnectHost(false)
    }

    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayConnectHost} footer={null} onCancel={() => { setDisplayConnectHost(false); }}>
            <div style={{ fontWeight: "600", color: "white" }}>
                <svg style={{ position: "relative", top: 3 }} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 25 25">
                    <g id="Group_27" data-name="Group 27" transform="translate(-1244.741 -83)">
                        <path id="Path_5802" data-name="Path 5802" d="M278.333,189.963a3.321,3.321,0,0,0-4.7-4.7,3.288,3.288,0,0,0-.958,2.192l-7.008,4.807-5.884-5.883a1.129,1.129,0,0,0-1.552,0,13.422,13.422,0,0,0,18.982,18.981,1.1,1.1,0,0,0,0-1.551l-5.884-5.883,4.806-7.007a3.292,3.292,0,0,0,2.195-.958Zm-3.148-3.144a1.128,1.128,0,0,1,1.6,1.593,1.152,1.152,0,0,1-1.183.247c-.021-.007-.044-.013-.064-.021a1.071,1.071,0,0,1-.347-.225h0a0,0,0,0,1,0,0,1.107,1.107,0,0,1-.18-.244c-.009-.016-.018-.033-.027-.049a1.16,1.16,0,0,1-.1-.292.047.047,0,0,0,0-.008,1.086,1.086,0,0,1-.019-.2,1.123,1.123,0,0,1,.329-.8ZM267.726,207.1a11.229,11.229,0,0,1-8.679-18.352l5.715,5.713,0,0,1.041,1.04,9.048,9.048a11.153,11.153,0,0,1-7.127,2.548Zm2.028-10.75-2.506-2.505,6.111-4.192a3.345,3.345,0,0,0,.587.586Z" transform="translate(990.438 -101.294)" fill="#fff" />
                    </g>
                </svg>
                <span style={{ marginLeft: 5 }}>Connect to remote host</ span> </div>
            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Host IP</label>
                <Input value={host.host_ip} onChange={(e) => { setHost({ ...host, host_ip: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter Host IP" />
            </div>

            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button onClick={() => { onConnectHost(host) }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
            </div>
        </Modal>
    );
};

export default ConnectToRemote;